/** Resolve a downloadable file URL from assorted report API response shapes. */
export const extractReportDownloadUrl = (payload) => {
  if (!payload) return '';
  if (typeof payload === 'string') {
    const s = payload.trim();
    return s.startsWith('http') || s.startsWith('/') ? s : '';
  }

  const roots = [payload, payload.data, payload.result, payload.report].filter(Boolean);

  const pickString = (v) => {
    if (!v) return '';
    if (typeof v === 'string') {
      const s = v.trim();
      return s.startsWith('http') || s.startsWith('/') ? s : '';
    }
    if (typeof v === 'object') {
      return (
        pickString(v.fileUrl) ||
        pickString(v.objectUrl) ||
        pickString(v.url) ||
        pickString(v.signedUrl) ||
        pickString(v.s3Url) ||
        pickString(v.downloadUrl)
      );
    }
    return '';
  };

  for (const root of roots) {
    const direct = pickString(
      root.pdfUrl ??
        root.fileUrl ??
        root.url ??
        root.reportUrl ??
        root.downloadUrl
    );
    if (direct) return direct;

    const nested = pickString(
      root.reportDetails ??
        root.pdfReportDetails ??
        root.onePageReportDetails ??
        root.flashReportDetails ??
        root.report_url?.Report_s3Url ??
        root.report_url
    );
    if (nested) return nested;
  }

  return '';
};

/** Map DPR/DSR log GET fields → per–report-type download URLs for the generate modal. */
export const extractReportUrlsFromLogRecord = (logRecord) => {
  if (!logRecord || typeof logRecord !== 'object') {
    return { pdf: '', flash: '', onepage: '' };
  }
  const rd = logRecord;
  const fromDetails = (key) => extractReportDownloadUrl(rd[key]);
  return {
    pdf: fromDetails('reportDetails') || fromDetails('pdfReportDetails') || fromDetails('dprPdfReportDetails'),
    flash: fromDetails('flashReportDetails') || fromDetails('shiftFlashReportDetails'),
    onepage: fromDetails('onePageReportDetails') || fromDetails('onePagePdfReportDetails')
  };
};

export const openReportDownloadUrl = (url) => {
  const u = String(url || '').trim();
  if (!u) return false;
  window.open(u, '_blank', 'noopener,noreferrer');
  return true;
};
